module.exports = __webpack_public_path__ + "img/img_step01@2x.7b68204a.png";